import {useContext} from "react";
import {INotificationContext} from "../contexts/models/INotificationContext.ts";
import {NotificationContext} from "../contexts/NotificationContext.tsx";

export const useNotification = () => {
    return useContext<INotificationContext>(NotificationContext);
};